<template>
  <a-modal 
    width="70%"
    :title="$t('alarm.fenceAlarm')"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="quit"
    destroyOnClose
  >
    <!-- {{alarmData.attr}} -->
    <DrawFence :alarmData="alarmData" />
  </a-modal>
</template>
<script>
import DrawFence from '@/components/FenceDrawer/FenceDrawer'
export default {
  components: {
    DrawFence
  },
  props: {
    alarmData: {
      required: true
    }
  },
  data () {
    return {
      visable: true,
    }
  },
  methods: {
    // 点击确定按钮
    handleOk () {
      // console.log('ok')
      this.visable = false
      this.$emit('quitModal')
    },
    // 点击X或者取消
    quit () {
      this.visable = false
      this.$emit('quitModal')
    },
  }
}
</script>
<style lang="less" scoped>
</style>
